// extracted by mini-css-extract-plugin
export var btnRipple = "PromoButton-module--btn-ripple--df9bd";
export var ripples = "PromoButton-module--ripples--c7ffe";